module.exports = __webpack_public_path__ + "img/footer_img_myself.43dea490.jpg";